import { createSlice } from "@reduxjs/toolkit";
import { store } from "../../store";
import { axiosInstance } from "../../../utils/client";

interface CityState {
  isLoading: boolean;
  error: string | false;
  cities: any[];
}

const initialState: CityState = {
  isLoading: false,
  error: false,
  cities: [],
};

const citySlice = createSlice({
  name: "city",
  initialState,
  reducers: {
    setCities: (state, action) => {
      state.isLoading = false;
      state.cities = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { setCities, setLoading, setError } = citySlice.actions;
export default citySlice.reducer;

export function fetchCities() {
  return async (dispatch: any, getState: () => any) => {
    // const { dispatch } = store;
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/cities`);
      // console.log(response);
      if (response.data) {
        dispatch(
          setCities(
            response.data.map((city: any) => ({
              value: city.id,
              label: city.name,
            }))
          )
        );
      } else {
        dispatch(setError(response.data));
      }
    } catch (error) {
      console.log(error);
      dispatch(setError(error));
    }
  };
}
